import {useStore} from "vuex";
import {computed} from "vue";

export function useHeader() {
    const store = useStore();
    const subHeader = computed(function () {
        return store.state.subHeader.data;
    });
    const showSchemaOrg = ()=> {

        if(store.state.subHeader.data.breadcrumbs) {
            let recaptchaScript = document.createElement('script');
            recaptchaScript.setAttribute('type', 'application/ld+json');
            let items = [];
            for (let index in store.state.subHeader.data.breadcrumbs) {
                let tmp = {
                    "@type": "ListItem",
                    "position": ((index*1)+1),
                    "name": store.state.subHeader.data.breadcrumbs[index].TITLE,
                };
                if(((index*1)+1)<store.state.subHeader.data.breadcrumbs.length) {
                    tmp['item'] = store.state.subHeader.data.breadcrumbs[index].ABSOLUTE_LINK;
                }
                items.push(tmp);
            }
            recaptchaScript.innerHTML = `{"@context": "https://schema.org","@type": "BreadcrumbList","itemListElement": `+JSON.stringify(items)+`}`;
            document.body.appendChild(recaptchaScript);

        }


    }
    return {
        subHeader,
        showSchemaOrg
    }
}